import BasicModal from "../_widgets/Modal/BasicModal";

import { Table } from "react-bootstrap";
import { formattedValue } from "../../Services/common";
import { changeDateTimeFormatForDisplay } from "../../Utils/dateUtils";
import ImageResource from "../../Wrapper/ImageResource/ImageResource";
import MainLoader from "../_widgets/Loader/MainLoader";
import CustomPagination from "../_widgets/Pagination/Pagination";
import Text from "../_widgets/Text/Text";

const HistoryModal = ({
  modalShow,
  setModalShow,
  handleClose,
  loading,
  addInventory,
  buttonLoading,
  handleHistoryPageChange,
}) => {
  return (
    <BasicModal
      show={modalShow}
      size="xl"
      setModalShow={setModalShow}
      handleClose={handleClose}
      heading={`Inventory History`}
      footer
      minH={`${60}vh`}
      loading={buttonLoading}
    >
      <div className="patient_list white_card">
        {loading ? (
          <div className="position-relative h-100">
            <MainLoader />
          </div>
        ) : addInventory?.data?.length < 1 ? (
          <div className="no_data position-relative text-center" style={{ minHeight: "auto" }}>
            <ImageResource type="noData" style={{ width: "300px" }} className="img-fluid" />
            <Text type="h2" text="There is no data to display!" />
          </div>
        ) : (
          <>
            <Table responsive hover>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Qty</th>
                  <th>Type</th>
                  <th>Remarks</th>
                  <th>Patient Name</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {addInventory?.data?.map((data) => {
                  return (
                    <tr key={data?.id}>
                      <td>{changeDateTimeFormatForDisplay(data?.date)}</td>
                      <td>{data?.qty ? formattedValue(data?.qty, false, true) : "-"}</td>
                      <td>{data?.type ? data?.type : "-"}</td>
                      <td>{data?.remarks ? data?.remarks : "-"}</td>
                      <td>{data?.patient?.name ? data?.patient?.name : "-"}</td>
                      <td className="right-align">
                        {data?.balance ? formattedValue(data?.balance, false, true) : "0.00"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            <CustomPagination
              activePage={addInventory?.current_page}
              onPageChange={handleHistoryPageChange}
              pageLength={addInventory?.per_page}
              totalData={addInventory?.total}
              lastPage={addInventory?.last_page}
            />
          </>
        )}
      </div>
    </BasicModal>
  );
};

export default HistoryModal;
